import React from "react"

import { useCurrentOutfitter } from "~components/providers/current-outfitter-provider"
import Feed from "~components/shared/feed"
import { FeedGroup } from "~graphql/generated/graphql"

export default function OutfitterFeed() {
    const { currentOutfitter } = useCurrentOutfitter()

    return (
        <Feed
            title={currentOutfitter.name}
            feedId={currentOutfitter.id}
            feedGroup={FeedGroup.User}
            avatar={currentOutfitter.avatar}
        />
    )
}
